import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * AuthRouteGuard - Prevents Login/Register pages from rendering when authenticated
 * 
 * Wraps /login and /register routes to immediately redirect authenticated users
 * to their appropriate dashboard WITHOUT rendering the login/register page at all.
 * 
 * This prevents the "login page flash" after successful authentication.
 */
const AuthRouteGuard = ({ children }) => {
  const { authStatus, user } = useAuth();

  // If authenticated, redirect to appropriate dashboard
  // This happens BEFORE the login/register page renders
  if (authStatus === 'authenticated' && user) {
    const userRole = user.role || 'member';
    const isAdmin = userRole === 'admin' || userRole === 'primary_admin';
    
    // Redirect based on role
    const redirectPath = isAdmin ? '/partner-pro/dashboard' : '/partner-pro/workspace';
    
    console.log('[AUTH ROUTE GUARD] Already authenticated, redirecting to:', redirectPath);
    return <Navigate to={redirectPath} replace />;
  }

  // Not authenticated (or still checking) - render the auth page
  // Note: GlobalAuthGate handles the "checking" state, so we only reach here
  // when authStatus is "unauthenticated"
  return <>{children}</>;
};

export default AuthRouteGuard;
